(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.analytics'

  angular
    .module(MODULE_NAME, [
      require('./analytics'),
      require('./directive/analytics-on'),
      require('./directive/analytics-videogular')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/analytics/index.js